import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();

  if (checking || user === null) {
    return (
      <div className="min-h-screen bg-ink-950 grid place-items-center">
        <Loader2 className="animate-spin text-brand" size={28} />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
